import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Navbar2 from '../Navbar2/index2'
import "./Hero2.css"

const HeroSection = () => {
   const [isOpen, setIsOpen] = useState(false)
    
   const toggle = () => {
    setIsOpen(!isOpen)
   }
  return (
    <>
    <Sidebar isOpen={isOpen} toggle={toggle}/>
    <Navbar2 toggle={toggle}/>
    <div className='HeroContainer2'>
       
        <div className='HeroBackg'>
          <div className='HeroBg2'>
            
          </div>
        </div>
    </div>
    </>
  )
}

export default HeroSection